import useAxios from 'hooks/useAxios';

export async function getCountries() {
  const api = useAxios();

  try {
    const res = await api.get('blacklisted-countries/all-countries-by-continent');
    return res;
  } catch (err) {
    return err;
  }
}
